import { useNavigate } from "react-router-dom"
import { Footer } from "../../../Footer/Footer"
import { HerosectionsAll } from "../../../HeroSectionAll/HerosectionsAll"
import { Header } from "../../../IndexPage/Header/Header"


export const GeneralAverageClaims = () => {
    const navigate = useNavigate()
    const handleReadmore = () => {
        navigate('/GeneralAverageClaimsReadmore')
    }
    return (
        <>
 <div className="container-fluid">
            <div className="row " style={{ background: '#fff' }} >
                <div className="col-12">
                    <Header actives="GeneralAverageClaims" />
                    <HerosectionsAll ScreenName="General Average Claims" ScreenSearch="GeneralAverageClaims" />

                    <div className="row col-lg-11 mx-auto p-2 my-5 " onLoad={() => window.scrollTo(0, 0)}>
                        <div className="col-12  p-4" style={{ textAlign: 'justify', }}>
                            {/* <div className="d-flex justify-content-center">
                                <div className="pe-1" style={{ width: '50%', textAlign: 'center' }}>
                                    <div class="card cardHeight" >
                                        <div class="card-body">
                                            <p class="card-title text-center fw-bold" style={{ fontSize: "25px", textDecoration: 'underline' }}><img src="Static/Assets/Img/bullet-point.png" className='pe-2' style={{ height: "26px" }} />
                                                Who Invented General Average?
                                            </p>
                                            <h3 class="card-text p-2 text-center" style={{ fontSize: "24px" }}>
                                                "If general average didn't exist, someone would have had to invent it."
                                            </h3>
                                            <p class="card-text float-end text-center">The opening sentence of a magazine article in March 1989 <span>
                                                Quoted in <span className="fw-bold">General Average and York-Antwerp Rules
                                                    By Lowndes and Rudolf </span> <br />
                                                (Twelfth Edition)
                                            </span>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div> */}
                            {/* <div>
                                <h5 className="fw-bold gray_color pb-2 mt-3">General Average Claims</h5>

                                <p>General Average originated well before the concept of insurance, with respondensia and Bottamary Bonds issued by shipping merchants were originated. The following quotation comes from a chapter of Justinian's Digest prove the same. </p>
                            </div> */}
                            <div className="px-lg-5 pb-lg-5 mx-auto col-lg-10 ">
                            <h3 className="text-center fw-bold">Edifice of General Average</h3>
                                {/* <img src="Static/Assets/Img/Principles/English Law.png" alt=""  style={{width:'80%', height:'71vh'}}/> */}
                                <img src="Static/Assets/Img/Principles/general average-01.png" alt=""  style={{width:'100%', height:'71vh'}}/>
                            </div>
                            <div className="p-lg-5 faint">
                            <h5 className="fw-bold gray_color pb-2 mt-3">General Average Claims</h5>

                            <p>General Average originated well before the concept of insurance, with respondensia and Bottamary Bonds issued by shipping merchants were originated. The following quotation comes from a chapter of Justinian's Digest prove the same. </p>

                            <p className="float-end">
                                <button className="btn button" onClick={handleReadmore}>
                                    <span> Read More</span>
                                </button>
                            </p>
                        </div>

                           

                        </div>


                    </div>


                    <Footer />
                </div>
            </div>
</div>

        </>
    )
}
